import { BaseRequest } from 'src/app/tools/models/dtos/base-request';import { Product } from '../../entities/master-data/product-entity';


export class ProductRequest extends BaseRequest{
  product : Product;
  constructor(userInfo){    
    super(userInfo);
    this.product = new Product();
  }
}